export default __webpack_public_path__ + "static/media/early-admission.74d88ec4.png";